
TPS.MainNav = {
    scrollPostion: 0,
    init: function () {
        TPS.MainNav.mobileToggle();

        jQuery('#member-flyout, #offCanvasLeft').on('opened.zf.offcanvas', function (e) {
            TPS.MainNav.scrollPostion = document.body.scrollTop;
            jQuery('body').css({
                'top': '-' + TPS.MainNav.scrollPostion + 'px'
            }).addClass('active-off-canvas');
        });

        jQuery('#member-flyout, #offCanvasLeft').on('closed.zf.offcanvas', function (e) {
            jQuery('body').css({
                'position': 'relative',
                'top': 'auto'
            }).removeClass('active-off-canvas');
            window.scrollTo(0, TPS.MainNav.scrollPostion);
        });

        jQuery('.members-nav a[href^="http"]').attr('target', '_blank');

        $('.mainCMSListMenuLI.has-children').click(function () {
            $(this).toggleClass("expanded");
        })

        $('.secondary-nav-title').click(function () {
            $(this).closest('.secondary-nav').toggleClass("expanded");
            $(this).toggleClass("expanded");
        })

        if ($('.secondary-nav:visible').length > 0) {
            TPS.MainNav.hideMainNavOnScroll();
        }

        // AODA fix for data-toggler foundation plugin to support
        // keyboard control of the toggler
        jQuery('[data-toggle]').on('keydown', function (e) {
            var _targets = $(this).data('toggle').split(' ');
            if (e.which === 13) {
                $(this).trigger('click');
                if (_targets.length === 1) {
                    $(`#${_targets[0]}`).focus();
                }
            }
        });

        // AODA fix for data-toggler foundation plugin to support
        // keyboard control of the toggler
        jQuery('[data-close]').on('keydown', function (e) {
            if (e.which === 13) {
                $(this).trigger('click');
                $('#main-content-wrapper').focus();
            }
        });

    },

    mobileToggle: function () {
        // stuff
        jQuery(document).on('click', '.open-mobile-nav', function (e) {
            e.preventDefault();
            if (TPS.Util.getScreenWidth() < 1024) {
                var isActive = TPS.Util.checkActive('body', 'active-mobile-nav');
                var isAnim = TPS.Util.checkAnimated('.site-nav-wrapper');

                if (!isActive && !isAnim) {
                    jQuery('body').addClass('active-mobile-nav');
                } else if (isActive && !isAnim) {
                    jQuery('body').removeClass('active-mobile-nav');
                }
            }
        });

    },

    hideMainNavOnScroll: function () {
        window.onscroll = function (e) {
            // Hide main nav when scrolled over
            // make sub-nav sticky top
            if (this.scrollY > $('nav').outerHeight()) {
                $('body').addClass('subnav-fixed');
            } else {
                $('body').removeClass('subnav-fixed');
            }

            // Show main nav fixed on top when scolling up
            if (this.oldScroll > this.scrollY) {
                $('body').addClass('scrolling-up');
            } else {
                $('body').removeClass('scrolling-up');
            }
            this.oldScroll = this.scrollY;
        }
    }
}
